import {Cliente} from '../../../class';

export const clienteAdminMixins = {
    data () {
        return {
            cliente: null
        };
    },
    methods: {
        async loadCliente (id) {
            this.cliente = await Cliente.byPKId(id);
        }
    }
};
